pageId = "page-invite-new"
page = "##{pageId}"

socket = null

$ ->
  tower.stack.on 'pageunload', (e, $page, pageParams) ->
    if $page.is(page)
      socket?.disconnect?()
      socket = null
    return e.result


$(document).on "pjaxload##{pageId}", (e, $page, page) ->
  tower.fetchQrcode()

  if $("[data-trial-surpass-members-limit='true']").length > 0
    tower.showTrialTeamSurpassMembersLimit()


tower.fetchQrcode = ->
  $qrcode = $('.wechat-invite .qrcode-wrap')
  return  unless $qrcode.length

  $.ajax
    url: $qrcode.data 'url'
    type: 'get'
    dataType: 'json'
    success: (result) ->
      if result.success
        $qrcode.find('img.qrcode')
          .attr('src', result.qrcode_url)
          .end().removeClass('loading')
          .find('.indicator').remove()
